import LicensePlate from "../../../../common/LicensePlate/LicensePlate";
import tools from "../../../../../helpers/tools";
import styles from "./FlotteTable.module.scss";
import { getAnomaliesFacturation } from "./FlotteUtils";

// Colonne de synthèse figée (LS-707) : reprend les informations de la bulle
// de survol (SummaryCard) pour les garder visibles en permanence pendant le
// défilement horizontal. Pilotée par sa propre case à cocher, elle ne figure
// pas dans le sélecteur de colonnes ni dans columnsConfig.

export const StickyIdentiteHeader = () => (
  <th className={styles.stickyIdentiteHeader}>
    <span style={{ fontSize: 12.5 }}>Véhicule</span>
  </th>
);

export const StickyIdentiteCell = ({ item }) => {
  const identification = item?.identification || {};
  const contrat = item?.contrat || {};
  const marqueModele = [identification.marque, identification.modele]
    .filter(Boolean)
    .join(" ");
  const anomaliesFacturation = getAnomaliesFacturation(item);

  return (
    <td className={styles.stickyIdentiteCell}>
      <div className="d-flex align-items-center" style={{ gap: 6 }}>
        <LicensePlate
          value={identification.immatriculation}
          size="sm"
          copyable={false}
        />
        <strong className={styles.identiteLigne} title={marqueModele}>
          {marqueModele || "—"}
        </strong>
      </div>
      <div
        className={`${styles.identiteLigne} text-muted small`}
        title={contrat.intitule_client || undefined}
      >
        {contrat.intitule_client || "—"}
      </div>
      <div className="text-muted small" style={{ whiteSpace: "nowrap" }}>
        {contrat.duree_mois ? `${contrat.duree_mois} mois` : "—"}
        {" · "}
        {contrat.kilometrage
          ? `${tools.beautiFyNumberformatNumberSpaces(contrat.kilometrage)} km`
          : "—"}
      </div>
      {/* LS-742 : la colonne figée remplace la bulle de survol, elle porte donc
          aussi les causes de l'anomalie de facturation */}
      {anomaliesFacturation.length > 0 && (
        <div
          className={`${styles.identiteLigne} text-danger small`}
          title={anomaliesFacturation.join("\n")}
        >
          <i className="fas fa-exclamation-triangle mr-1"></i>
          {anomaliesFacturation.join(" · ")}
        </div>
      )}
    </td>
  );
};
